export default __webpack_public_path__ + "static/media/payment-err.e7b79dae.svg";